export interface NegativeCasesState {
  chart: string;
  orders: string;
  accounts: string;
  managers: string;
}

export enum NegativeMessages {
  NoData = 'No Data Selected. Please Select a Series',
  NoDealOrders = 'No Orders Have Been Submitted',
  NoFilteredDealOrders = 'No Results for Filter Options',
  AccountsDisabled = 'You Do Not Have Access to Account Details'
}
